import { Select } from 'antd'
import _ from 'lodash'
import { useAppConfig } from 'modules/local'
import React, { useMemo } from 'react'
import { SelectWidget } from 'views/AppLocals/custom/ReactSelectComponents'

export const SelectCountries = ({ value, placeholder, onChange, ...selectProps }) => {
  const { countries = [] } = useAppConfig()

  const options = useMemo(
    () =>
      _.flatten(countries).map(({ id, common_name }, i) => (
        <Select.Option
          key={i}
          value={id}
          common_name={common_name}>
          {common_name}
        </Select.Option>
      )),
    [countries]
  )

  return (
    <SelectWidget
        {...selectProps}
        value={value}
        showSearch={true}
        onChange={onChange}
        placeholder={placeholder}
        optionFilterProp="children"
        style={{ display: 'block', width: '100%', borderRightWidth: 0 }}
        loading={_.isEmpty(countries)}
        filterOption={(input, option) =>
            option.props.common_name.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
      {options}
    </SelectWidget>
  )
}
